import {
  getExistingFieldValue,
  createFieldDataObjAndArray,
  validateFormFields,
} from 'AppSrc/core/components/forms/form-section-utility-functions';
import { createCrqSectionGetCurrentFields } from 'AppSrc/core/components/forms/form-types/create-crq/form-definition/current-fields';
import {
  currentSelectedNetwork,
  userRoleForSelectedNetwork,
} from 'AppSrc/core/components/forms/form-types/create-crq/common-logic';
import {
  CHANGE_TYPE,
  CHANGE_QUESTIONS,
  CHANGE_DETAILS,
} from 'AppSrc/core/components/forms/form-types/create-crq/form-definition/section-constants';
import {
  WORK_INFORMATION_ITEMS,
} from 'AppSrc/core/components/forms/form-types/create-crq/section-five/section-five';
import { RELATIONSHIPS } from 'AppSrc/core/components/forms/form-types/create-crq/relationships/relationships';
import { relationshipsField } from 'AppSrc/core/components/forms/form-types/create-crq/relationships/relationships-modal/relationships-field';
import { CREATE_CRQ } from 'AppSrc/core/components/create-crq-screen/create-crq-screen-consts';
import { calculateRiskLevel } from 'AppSrc/core/components/forms/form-types/create-crq/section-two/section-two-data-layer-functions';
import { fileDb } from 'AppSrc/core/utility-storage/file-db';
import { selectNetworkParams } from 'AppSrc/core/components/forms/form-types/create-crq/section-one/select-network-params';
import { MOBILE } from 'AppSrc/core/components/forms/value-dependency-constants';
import {
  ES_VIEWING_NEW_SECTION,
  ES_VIEWING_EDIT_SECTION,
  COORDINATOR,
} from 'AppSrc/core/components/forms/form-base-components/data-structure/constants';
import { assignSponsor } from 'AppSrc/core/components/forms/form-types/create-crq/section-four/assign-sponsor';
// import { COORDINATOR } from 'AppSrc/core/components/forms/form-base-components/data-structure/constants';


// some sections have additional actions that need performing like calculating the risk
// level in section 2
const sectionSpecificActions = (params) => {
  const {
    formId,
    crqId,
    sectionData,
    dispatch,
    currentFormData,
    actions,
    editingStatus,
    userRoles,
  } = params;


  const {
    deleteAllDataForForm,
    setCreateCrqCoordinatorToLoggedInUser,
    setRiskValue,
    setSponsor,
    setUnsavedRelationships,
  } = actions;

  const selectedNetwork = currentSelectedNetwork(currentFormData);
  const selectedRole = userRoleForSelectedNetwork(currentFormData, userRoles);


  /* Section specific actions that need to be ran when creating AND editing a CRQ */

  if (sectionData.sectionId === WORK_INFORMATION_ITEMS) {
    fileDb.deleteAllMarked();
  }

  if (sectionData.sectionId === CHANGE_QUESTIONS) {
    if (selectedNetwork === MOBILE) {
      const riskValue = calculateRiskLevel(sectionData.dataByFieldId);
      dispatch(setRiskValue({
        formId,
        riskValue,
        crqId,
      }));
    }
  }
  if (sectionData.sectionId === CHANGE_DETAILS) {
    if (selectedNetwork === MOBILE && selectedRole === COORDINATOR) {
      // check if a new value has been entered for sponsor
      const sponsor = sectionData.dataByFieldId[assignSponsor.id].value;
      const currentSection = currentFormData.dataByFormSectionId[CHANGE_DETAILS];
      const currentSponsor = currentSection ? currentSection.dataByFieldId[assignSponsor.id].value : null;
      if (sponsor !== currentSponsor) {
        // set a new value for sponsor in the formData
        dispatch(setSponsor({
          formId,
          crqId,
          sponsor,
        }));
      }
    }
  }

  if (sectionData.sectionId === RELATIONSHIPS) {
    if (selectedNetwork === MOBILE) {
      const newModal = sectionData.dataByFieldId[relationshipsField.id].value;
      const currentSection = currentFormData.dataByFormSectionId[RELATIONSHIPS];
      const currentModal = currentSection ? currentSection.dataByFieldId[relationshipsField.id].value : null;
      if (newModal) {
        // create an array of relationship ids that have changes
        const sectionIdsWithChanges = newModal.formSectionsByDisplayOrder.filter((sectionId) => {
          const currentRelationship = currentModal ? currentModal.dataByFormSectionId[sectionId] : null;
          // if the relationship is new, include it in the array
          if (!currentRelationship) {
            return true;
          }
          const newRelationshipJson = JSON.stringify(newModal.dataByFormSectionId[sectionId]);
          const currentRelationshipJson = JSON.stringify(currentRelationship);
          // include relationship id in the array if the data is different to the existing data
          return newRelationshipJson !== currentRelationshipJson;
        });
        // create an array of relationships that have been deleted
        const deletedRelationshipsIds = [];
        if (currentModal) {
          currentModal.formSectionsByDisplayOrder.forEach((sectionId) => {
            const newModalHasRelationship = newModal.formSectionsByDisplayOrder.includes(sectionId);
            if (!newModalHasRelationship) {
              const relationship = currentModal.dataByFormSectionId[sectionId];
              if (relationship) {
                deletedRelationshipsIds.push(relationship.relationshipId);
              }
            }
          });
        }
        // array of unsaved relationships.
        // each entry is either a relationshipId to delete (with toDelete = true)
        // or a sectionId to update (with toDelete = false)
        const unsavedRelationships = [
          ...sectionIdsWithChanges.map((sectionId) => ({ sectionId, toDelete: false })),
          ...deletedRelationshipsIds.map((relationshipId) => ({ relationshipId, toDelete: true })),
        ];
        // dispatch action to set the unsaved relationships in redux
        dispatch(setUnsavedRelationships({
          formId,
          crqId,
          unsavedRelationships,
        }));
      }
    }
  }


  /* Section specific actions to only fire whilst raising a new CRQ */


  const editStatusIsViewing = (editingStatus === ES_VIEWING_NEW_SECTION) || (editingStatus === ES_VIEWING_EDIT_SECTION);

  // No ops out of doing other actions. May be worth extracting this out into two functions at some point...
  if (editStatusIsViewing) {
    return null;
  }

  if (sectionData.sectionId === CHANGE_TYPE) {

    const selectedNetworkFieldData = sectionData ? sectionData.dataByFieldId[selectNetworkParams.id] : null;
    // The network we're about to set in state
    const newSelectedNetwork = selectedNetworkFieldData ? selectedNetworkFieldData.value[0] : undefined;
    const newOloNetwork = (newSelectedNetwork === 'fixedOlo' || newSelectedNetwork === 'fixedInternational') ? 'fixed' : newSelectedNetwork;
    if (newSelectedNetwork && (newOloNetwork !== selectedNetwork)) {
      dispatch(deleteAllDataForForm(CREATE_CRQ));
    }


    // if we have selected a network, set the coordinator in redux
    if (newSelectedNetwork) {
      dispatch(setCreateCrqCoordinatorToLoggedInUser(newSelectedNetwork));
    }
  }
  return null;
};


// FN: 19/02/2020
// sectionSpecificActions can have drastic affects on the the form's data. For example, changing from fixed to mobile
// in sectionOne deletes all of the form data. As such, it's important to preserve the order of sectionSpecificActions
// followed by the action to save the form data (saveSectionAction). In the given case, we want to delete all of the
// formData but then immediatly save
// sectionOne
const doSectionSpecificActionsAndsaveFormData = (params) => {
  const {
    formId,
    crqId,
    sectionData,
    dispatch,
    currentFormData,
    actions,
    editingStatus,
    userRoles,
  } = params;

  const {
    saveSectionAction,
  } = actions;

  if (!saveSectionAction) {
    console.error('Unable to update the form data as no saveSectionAction was provided!');
  }

  sectionSpecificActions({
    formId,
    crqId,
    sectionData,
    dispatch,
    currentFormData,
    actions,
    editingStatus,
    userRoles,
  });

  // This is an action that is passed in and needs different paramaters depending on what is passed in.
  // ie, if this is passed in from edit-form, it needs crqId and sectionData. If this is passed in from
  // main-form however it needs formId and sectionData.
  dispatch(saveSectionAction({
    formId,
    crqId,
    sectionData,
  }));
};




const reValidateSection = (inputParams) => {

  const {
    formId,
    crqId,
    formData,
    sectionData,
    dispatch,
    userRoles,
    actions,
    editingStatus,
    network,
  } = inputParams;

  const {
    saveFormSectionErrorsAction,
  } = actions;

  if (!saveFormSectionErrorsAction) {
    console.error('Unable to provide formSectionErrors as saveFormSectionErrorsAction was not passed in!');
  }
  const selectedNetwork = currentSelectedNetwork(formData);



  const {
    sectionId,
  } = sectionData;
  // creates an array of values (in the same structure that Formik does)
  const values = {};
  sectionData.fieldIdsByDisplayOrder.forEach((fieldName) => {
    const value = getExistingFieldValue(fieldName, sectionData);
    values[fieldName] = value;
  });

  // creates the params for getCurrentFields
  const params = {
    values,
    formData,
    // touched = {},
    userRoles,
    network,
  };



  // currentFields contains logic about the fields that should be displayed in a section and handles the
  // complex interactions between them.
  const getCurrentFields = createCrqSectionGetCurrentFields[sectionId];
  const currentFields = getCurrentFields(params);

  // dataByFieldId is is the values for currentFields processed for the data layer, taking into consideration
  // the complex interactions betweem them. ie, if changes to sectionOne's data means changes to sectionTwo's
  // data, this is where this will occur.
  const {
    dataByFieldId,
  } = createFieldDataObjAndArray({
    currentFields,
    values,
    selectedNetwork,
  });

  const newSectionData = {
    ...sectionData,
    dataByFieldId,
  };

  doSectionSpecificActionsAndsaveFormData({
    formId,
    crqId,
    sectionData: newSectionData,
    dispatch,
    currentFormData: formData,
    actions,
    editingStatus,
    userRoles,
  });

  // generate and dispatch errors for the section
  const errors = validateFormFields({
    currentFields,
    values,
    userRoles,
    formData,
    sectionId,
  });

  dispatch(saveFormSectionErrorsAction({
    formId,
    crqId,
    sectionId,
    errors,
  }));
};


export {
  doSectionSpecificActionsAndsaveFormData,
  reValidateSection,
};


